export default __webpack_public_path__ + "static/media/right.d74a4397.svg";